var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRedIFull(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5 6.5C12.5 3.1925 9.8075 0.5 6.5 0.5C3.1925 0.5 0.5 3.1925 0.5 6.5C0.5 9.8075 3.1925 12.5 6.5 12.5C9.8075 12.5 12.5 9.8075 12.5 6.5ZM7.25 8.75L7.25 10.25H5.75L5.75 8.75H7.25ZM7.25 2.75V7.25H5.75V2.75H7.25Z",
    fill: "#DF666A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedIFull);
export default __webpack_public_path__ + "static/media/red-i-full.337e4620afef9e76596114212ccb9f13.svg";
export { ForwardRef as ReactComponent };